





































export default {
  name: "PasienMultiWarningIndicator",
  props: {
    active: {
      type: Boolean,
      default: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "25"
    },
    color: {
      type: String,
      default: "gray"
    },
    icon: {
      type: String,
      default: "mdi-alert-octagram"
    },
    activeText: {
      type: [String, Array],
      default: null
    },
    inactiveText: {
      type: String,
      default: null
    },
    actionable: {
      type: Boolean,
      default: false
    },
    countBadge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // toggleProgress: false
    };
  },
  methods: {
    toggleActive() {
      this.$emit("toggleActive");
    }
  },
  computed: {
    text() {
      if (this.active) {
        return Array.isArray(this.activeText)
          ? this.activeText.join("<br/>")
          : this.activeText;
      } else {
        return this.inactiveText;
      }
    },
    count() {
      if (Array.isArray(this.activeText)) {
        return this.activeText.length;
      }
      return this.active && this.activeText ? 1 : 0;
    }
  }
};
